import React from 'react';
import QueueAnim from 'rc-queue-anim';
import ForgotSetPassword from '../../form/routes/forms/components/ForgotSetPassword'

const FormCard = () => (
  <section className="form-card-page row no-gutters">

    <div className="card form-card__body col-lg-6 offset-lg-3 p-5 px-lg-8 d-flex align-items-center justify-content-center mt-5 border-0">
      <ForgotSetPassword />
    </div>
  </section>
)

const Page = () => (
  <QueueAnim type="bottom" className="ui-animate">
    <div key="1">
      <FormCard />
    </div>
  </QueueAnim>
)

export default Page;
